/* global tinymce */
import { v4 as uuidv4 } from "uuid";
import { states } from "../../../data/us_states";
import definedAbility from "@/ability";
const ability = definedAbility();

import {
  getCTATemplate,
  getShortCTATemplate,
  getQuoteBoxTemplate,
  getQuoteTemplate,
  getSelectAgeTemplate,
  getSelectAgeIconsTemplate,
  getMileageTemplate,
  getTeamMembersTemplate,
  getReviewRatingsTemplate,
  getDripFormTemplate,
  getSocialSharerTemplate,
  getCommentsTemplate,
  getContactFormTemplate,
  getTextHighlightTemplate,
  getDynamicHighlightBoxTemplate,
  getCheckoutPlanTemplate,
  getUsStatesShortcodeTemplate,
  getCTAIndyTemplate,
  getCTAOuterTemplate,
  getGifAgeTemplate,
  getMultiButtonCta,
  getMultiButtonCtaWithImages,
  getWhiteMultiButtonCta,
  getDynamicColorMultiButtonCta,
  getCTATemplateWidthAd,
  getMultipleCTATemplate,
  getCheckoutFormTemplate,
  getEmailFormTemplate,
  getSelectAgeInOneRowTemplate,
  getAgeCTA3Template,
  getSkinnyAgeButtonsTemplate,
  getMultiStepQuizTemplate,
  getMultiStepQuizWithLoaderTemplate,
  getMultiStepQuizV2WithLoaderTemplate,
  getMultiStepQuizV2Template,
  getCtaButtonNumberTemplate,
  getCTAPhoneTemplate,
  getShortcodeHTMLTemplate,
  getTimerTemplate,
  getContentSplitTemplate,
  getToastTemplate,
  getLiveChatTemplate,
  getLiveChatAutoTemplate,
  getBottomBarTemplate,
  getAudioFormTemplate,
  getAnimatedButtonTemplate,
  getCounterTemplate,
  getCarrierNamesOtcTemplate,
  getCarrierNamesPartBTemplate,
  getZipCodeTemplate,
  getMultiStepQuizV3Template,
  getMultiStepQuizV4Template,
  getMultiButtonCtaV3Template,
  getMoneyCTATemplate,
  getMultiButtonCtaV4Template,
  getButtonsWithTextBoxTemplate,
  getAgeCTA4Template,
  getCountdownTemplate,
  getLiveChatCTATemplate,
} from "../shortcodes/templates";

import { multipleCTAConfig } from "../shortcodeConfigs/multiplyCTAButtons";
import { selectAgeInOneRowConfig } from "../shortcodeConfigs/selectAgeInOneRowConfig";
import { ageCTA3Config } from "../shortcodeConfigs/ageCTA3Config";
import { ageCTA4Config } from "../shortcodeConfigs/ageCTA4Config";
import { selectAgeIconsConfig } from "../shortcodeConfigs/selectAgeIconsConfig";
import { selectMileageConfig } from "../shortcodeConfigs/selectMileageConfig";
import { dynamicTextHighlightConfig } from "../shortcodeConfigs/dynamicTextHighlightConfig";
import { dripFormConfig } from "../shortcodeConfigs/dripFormConfig";
import { multiStepQuizConfig } from "../shortcodeConfigs/multiStepQuizConfig";
import { multiStepQuizV2Config } from "../shortcodeConfigs/multiStepQuizV2Config";
import { multiStepQuizV3Config } from "../shortcodeConfigs/multiStepQuizV3Config";
import { multiStepQuizV4Config } from "../shortcodeConfigs/multiStepQuizV4Config";
import { commentsWidgetConfig } from "../shortcodeConfigs/commentsWidgetConfig";
import { ctaButtonNumberConfig } from "../shortcodeConfigs/ctaButtonNumberConfig";
import { multiButtonCtaConfig } from "@/assets/utilities/tinymce/shortcodeConfigs/multiButtonCtaConfig";
import { dynamicColorMultiCtaConfig } from "@/assets/utilities/tinymce/shortcodeConfigs/dynamicColorMultiCtaConfig";
import { customHTMLAdditionConfig } from "@/assets/utilities/tinymce/shortcodeConfigs/customHtmlConfig";
import { whiteMultiButtonCtaConfig } from "@/assets/utilities/tinymce/shortcodeConfigs/whiteMultiButtonCtaConfig";
import { multiButtonWithImagesConfig } from "@/assets/utilities/tinymce/shortcodeConfigs/multiButtonWithImagesConfig";
import { timerConfig } from "@/assets/utilities/tinymce/shortcodeConfigs/timerConfig";
import { ctaPhoneConfig } from "@/assets/utilities/tinymce/shortcodeConfigs/ctaPhoneConfig";
import { skinnyAgeButtonsConfig } from "@/assets/utilities/tinymce/shortcodeConfigs/skinnyAgeButtonsConfig";
import { singleCTAConfig } from "@/assets/utilities/tinymce/shortcodeConfigs/singleCTAConfig";
import { shortCTAConfig } from "@/assets/utilities/tinymce/shortcodeConfigs/shortCTAConfig";
import { liveChatCTAConfig } from "@/assets/utilities/tinymce/shortcodeConfigs/liveChatCTAConfig";
import { contentSplitConfig } from "@/assets/utilities/tinymce/shortcodeConfigs/contentSplitConfig";
import { toastConfig } from "@/assets/utilities/tinymce/shortcodeConfigs/toastConfig";
import { liveChatConfig } from "@/assets/utilities/tinymce/shortcodeConfigs/liveChatConfig";
import { liveChatAutoConfig } from "@/assets/utilities/tinymce/shortcodeConfigs/liveChatAutoConfig";
import { bottomBarConfig } from "@/assets/utilities/tinymce/shortcodeConfigs/bottomBarConfig";
import { audioFormConfig } from "@/assets/utilities/tinymce/shortcodeConfigs/audioFormConfig";
import { animatedButtonConfig } from "../shortcodeConfigs/animatedButtonConfig";
import { counterConfig } from "../shortcodeConfigs/counterConfig";
import { carrierNamesConfig } from "@/assets/utilities/tinymce/shortcodeConfigs/carrierNamesConfig";
import { multiButtonCtaV3Config } from "@/assets/utilities/tinymce/shortcodeConfigs/multiButtonCtaV3Config";
import { multiButtonCtaV4Config } from "@/assets/utilities/tinymce/shortcodeConfigs/multiButtonCtaV4Config";
import { buttonsWithTextBoxConfig } from "@/assets/utilities/tinymce/shortcodeConfigs/buttonsWithTextBoxConfig";
import { countdownConfig } from "@/assets/utilities/tinymce/shortcodeConfigs/countdownConfig";

const shortcodeOnClick = '<div data-shortcode-remove-onclick="true">x</div>';

const defaultButtonOptions = {
  url: "#",
  text: "",
  tab: "",
  type: "green",
};

const shortcodesList = [
  {
    text: "Button CTA #1",
    value: getCTATemplate(),
  },
  { text: "Button CTA #2", value: getCTAIndyTemplate(defaultButtonOptions) },
  {
    text: "Button CTA #3",
    value: getShortCTATemplate(),
  },
  { text: "Call CTA #1", value: getCTAPhoneTemplate() },
  { text: "Call CTA #2", value: getCtaButtonNumberTemplate() },
  { text: "Two-Button CTA", value: getMultipleCTATemplate() },
  { text: "Age CTA #1", value: getSelectAgeTemplate(defaultButtonOptions) },
  { text: "Age CTA #2", value: getSelectAgeInOneRowTemplate() },
  { text: "Age CTA #3", value: getAgeCTA3Template() },
  { text: "Blockquote #1", value: getQuoteBoxTemplate() },
  { text: "Blockquote #2", value: getQuoteTemplate() },
  { text: "Social Proof Element", value: getReviewRatingsTemplate() },
  { text: "Social Network Share Button", value: getSocialSharerTemplate() },
  { text: "Text Highlight Box", value: getDynamicHighlightBoxTemplate() },
  { text: "US States CTA", value: getUsStatesShortcodeTemplate(states, defaultButtonOptions) },
  { text: "Multi-Button CTA #1", value: getMultiButtonCta() },
  { text: "Multi-Button CTA #2", value: getDynamicColorMultiButtonCta() },
  ...(() => {
    if (ability.can("view", "multi-step-quiz shortcodes with loaders")) {
      return [
        { text: "Multi-Step Quiz #1", value: getMultiStepQuizWithLoaderTemplate() },
        { text: "Multi-Step Quiz #2", value: getMultiStepQuizV2WithLoaderTemplate() },
      ];
    } else {
      return [
        { text: "Multi-Step Quiz #1", value: getMultiStepQuizTemplate() },
        { text: "Multi-Step Quiz #2", value: getMultiStepQuizV2Template() },
      ];
    }
  })(),
  { text: "Video Embed / Custom HTML", value: getShortcodeHTMLTemplate() },
  { text: "Timer", value: getTimerTemplate() },
  { text: "Animated Button", value: getAnimatedButtonTemplate() },

  // Shortcodes for Inulti users only
  ...(() => {
    if (ability.can("view", "all shortcodes")) {
      return [
        { text: "Button CTA (With Ad)", value: getCTATemplateWidthAd(defaultButtonOptions) },
        { text: "Select Age Button (With Icons)", value: getSelectAgeIconsTemplate() },
        { text: "Skinny Age Buttons", value: getSkinnyAgeButtonsTemplate() },
        { text: "Select Mileage Button", value: getMileageTemplate() },
        { text: "Drip Form Widget", value: getDripFormTemplate() },
        { text: "Team members widget", value: getTeamMembersTemplate() },
        { text: "Comments Widget", value: getCommentsTemplate() },
        { text: "Contact Form", value: getContactFormTemplate() },
        { text: "Yellow Highlight Box", value: getTextHighlightTemplate("info-highlight") },
        { text: "Blue Highlight Box", value: getTextHighlightTemplate("info-blue") },
        { text: "Email form", value: getEmailFormTemplate() },
        { text: "Checkout Plan", value: getCheckoutPlanTemplate() },
        { text: "Checkout Form", value: getCheckoutFormTemplate() },
        { text: "CTA Outer Button", value: getCTAOuterTemplate(defaultButtonOptions) },
        { text: "Age Gif", value: getGifAgeTemplate(defaultButtonOptions) },
        { text: "Multi Button CTA with Images", value: getMultiButtonCtaWithImages() },
        { text: "Multi Button CTA (White)", value: getWhiteMultiButtonCta() },
        { text: "Content Split", value: getContentSplitTemplate() },
        { text: "Toast", value: getToastTemplate() },
        { text: "Live Chat", value: getLiveChatTemplate() },
        { text: "Live Chat - Auto", value: getLiveChatAutoTemplate() },
        // { text: "Audio Form", value: getAudioFormTemplate() },
        { text: "Bottom Bar", value: getBottomBarTemplate() },
        { text: "Counter", value: getCounterTemplate() },
        { text: "Carrier Names (OTC)", value: getCarrierNamesOtcTemplate() },
        { text: "Carrier Names (Part B)", value: getCarrierNamesPartBTemplate() },
        { text: "Zip Code", value: getZipCodeTemplate() },
        { text: "Multi-Step Quiz #3", value: getMultiStepQuizV3Template() },
        { text: "Multi-Step Quiz #4", value: getMultiStepQuizV4Template() },
        { text: "Multi-Button CTA #3", value: getMultiButtonCtaV3Template() },
        { text: "Multi-Button CTA #4", value: getMultiButtonCtaV4Template() },
        { text: "Money CTA", value: getMoneyCTATemplate() },
        { text: "Buttons With Text-Box", value: getButtonsWithTextBoxTemplate() },
        { text: "Age CTA #4", value: getAgeCTA4Template() },
        { text: "Countdown", value: getCountdownTemplate() },
        {
          text: "Livechat CTA #1",
          value: getLiveChatCTATemplate(),
        },
      ];
    } else {
      return [{ text: "Live Chat", value: getLiveChatTemplate() }];
    }
  })(),
].sort((a, b) => a.text.localeCompare(b.text));

const templateItems = [
  {
    type: "listbox",
    name: "shortcodesAddition",
    label: "Design elements",
    placeholder: "Select ",
    disabled: false,
    items: shortcodesList,
  },
];

const emailFormAdditionItems = {
  type: "panel",
  items: [
    {
      name: "sendEmailsToGroove",
      type: "checkbox",
      checked: false,
      label: "Send email to Groove",
    },
  ],
};

const dynamicShortcodeAddition = {
  title: "Design Elements",
  body: {
    type: "panel",
    placeholder: "Select ",
    items: templateItems,
  },
  buttons: [
    {
      type: "cancel",
      name: "closeButton",
      text: "Cancel",
    },
    {
      type: "submit",
      name: "submitButton",
      text: "Add",
      primary: true,
    },
  ],
  onChange: function () {},
  onSubmit: function (api) {
    const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();
    const uuid = uuidv4();
    let templateToAdd = api.getData().shortcodesAddition;
    let shortcodeWrapper;

    if (
      templateToAdd === getUsStatesShortcodeTemplate(states, defaultButtonOptions) ||
      templateToAdd === getCTAIndyTemplate(defaultButtonOptions) ||
      templateToAdd === getSelectAgeTemplate(defaultButtonOptions)
    ) {
      const optionsBody = {
        type: "panel",
        items: [
          {
            type: "input",
            name: "url",
            label: "URL",
            placeholder: "https://domain.com",
          },
          {
            type: "selectbox",
            name: "openLink",
            label: "Open link in...",
            items: [
              { value: "_self", text: "Same window tab" },
              { value: "_blank", text: "New window tab" },
            ],
          },
          {
            type: "selectbox",
            name: "type",
            label: "Button color",
            items: [
              { value: "green", text: "Green" },
              { value: "blue", text: "Blue" },
            ],
          },
        ],
      };
      if (templateToAdd === getCTAIndyTemplate(defaultButtonOptions)) {
        optionsBody.items.unshift({
          type: "input",
          name: "text",
          label: "Button text",
          placeholder: "Button text",
        });
      }

      let modalTitle = "CTA Options";
      if (templateToAdd === getCTAIndyTemplate(defaultButtonOptions)) {
        modalTitle = "Button CTA #2";
      } else if (templateToAdd === getSelectAgeTemplate(defaultButtonOptions)) {
        modalTitle = "Age CTA #1";
      } else if (templateToAdd === getUsStatesShortcodeTemplate(states, defaultButtonOptions)) {
        modalTitle = "US States CTA";
      }

      tinymce.activeEditor.windowManager.open({
        title: modalTitle,
        body: optionsBody,
        buttons: [
          {
            type: "cancel",
            name: "close",
            text: "Cancel",
          },
          {
            type: "submit",
            name: "submit",
            text: "Add",
            primary: true,
          },
        ],
        onSubmit: api => {
          const data = api.getData();

          if (templateToAdd === getUsStatesShortcodeTemplate(states, defaultButtonOptions)) {
            templateToAdd = getUsStatesShortcodeTemplate(states, {
              url: data.url,
              type: data.type,
              tab: data.openLink,
            });
          } else if (templateToAdd === getSelectAgeTemplate(defaultButtonOptions)) {
            templateToAdd = getSelectAgeTemplate({
              url: data.url,
              type: data.type,
              tab: data.openLink,
            });
          } else if (templateToAdd === getCTAIndyTemplate(defaultButtonOptions)) {
            templateToAdd = getCTAIndyTemplate({
              url: data.url,
              text: data.text,
              type: data.type,
              tab: data.openLink,
            });
          }

          shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd);
          addShortcodeToEditor(shortcodeWrapper, uuid, parentElement, api);
          api.close();
        },
      });
    } else if (
      templateToAdd === getCTAOuterTemplate(defaultButtonOptions) ||
      templateToAdd === getCTATemplateWidthAd(defaultButtonOptions)
    ) {
      let modalTitle = "CTA Options";
      if (templateToAdd === getCTAOuterTemplate(defaultButtonOptions)) {
        modalTitle = "CTA Outer Button";
      } else if (templateToAdd === getCTATemplateWidthAd(defaultButtonOptions)) {
        modalTitle = "Button CTA (With Ad)";
      }

      const optionsBodyWithoutBgOption = {
        type: "panel",
        items: [
          {
            type: "input",
            name: "text",
            label: "Button text",
            placeholder: "Button text",
          },
          {
            type: "input",
            name: "url",
            label: "URL",
            placeholder: "https://domain.com",
          },
          {
            type: "selectbox",
            name: "openLink",
            label: "Open link in...",
            items: [
              { value: "_self", text: "Same window tab" },
              { value: "_blank", text: "New window tab" },
            ],
          },
        ],
      };

      tinymce.activeEditor.windowManager.open({
        title: modalTitle,
        body: optionsBodyWithoutBgOption,
        buttons: [
          {
            type: "cancel",
            name: "close",
            text: "Cancel",
          },
          {
            type: "submit",
            name: "submit",
            text: "Add",
            primary: true,
          },
        ],
        onSubmit: api => {
          const data = api.getData();

          if (templateToAdd === getCTAOuterTemplate(defaultButtonOptions)) {
            templateToAdd = getCTAOuterTemplate({
              url: data.url,
              text: data.text,
              tab: data.openLink,
            });
          } else if (templateToAdd === getCTATemplateWidthAd(defaultButtonOptions)) {
            templateToAdd = getCTATemplateWidthAd({
              url: data.url,
              text: data.text,
              tab: data.openLink,
            });
          }

          shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd);
          addShortcodeToEditor(shortcodeWrapper, uuid, parentElement, api);
          api.close();
        },
      });
    } else if (templateToAdd === getGifAgeTemplate(defaultButtonOptions)) {
      const optionsBodyAgeGif = {
        type: "panel",
        items: [
          {
            type: "input",
            name: "url",
            label: "URL",
          },
          {
            type: "selectbox",
            name: "openLink",
            label: "Open link in...",
            items: [
              { value: "_self", text: "Same window tab" },
              { value: "_blank", text: "New window tab" },
            ],
          },
        ],
      };

      tinymce.activeEditor.windowManager.open({
        title: "CTA Options",
        body: optionsBodyAgeGif,
        buttons: [
          {
            type: "cancel",
            name: "close",
            text: "Cancel",
          },
          {
            type: "submit",
            name: "submit",
            text: "Add",
            primary: true,
          },
        ],
        onSubmit: api => {
          const data = api.getData();

          if (templateToAdd === getGifAgeTemplate(defaultButtonOptions)) {
            templateToAdd = getGifAgeTemplate({
              url: data.url,
              tab: data.openLink,
            });
          }

          shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd);
          addShortcodeToEditor(shortcodeWrapper, uuid, parentElement, api);
          api.close();
        },
      });
    } else if (templateToAdd === getCTATemplate()) {
      singleCTAConfig(tinymce, uuid, shortcodeOnClick);
    } else if (templateToAdd === getShortCTATemplate()) {
      shortCTAConfig(tinymce, uuid, shortcodeOnClick);
    } else if (templateToAdd === getLiveChatCTATemplate()) {
      liveChatCTAConfig(tinymce, uuid, shortcodeOnClick);
    } else if (templateToAdd === getMultipleCTATemplate()) {
      multipleCTAConfig(tinymce, uuid, shortcodeOnClick);
    } else if (templateToAdd === getSelectAgeInOneRowTemplate()) {
      selectAgeInOneRowConfig(tinymce, uuid, shortcodeOnClick);
    } else if (templateToAdd === getAgeCTA3Template()) {
      ageCTA3Config(tinymce, uuid, shortcodeOnClick);
    } else if (templateToAdd === getAgeCTA4Template()) {
      ageCTA4Config(tinymce, uuid, shortcodeOnClick);
    } else if (templateToAdd === getSkinnyAgeButtonsTemplate()) {
      skinnyAgeButtonsConfig(tinymce, uuid, shortcodeOnClick);
    } else if (templateToAdd === getDynamicHighlightBoxTemplate()) {
      dynamicTextHighlightConfig(tinymce, uuid, shortcodeOnClick);
    } else if (templateToAdd === getMultiStepQuizTemplate()) {
      multiStepQuizConfig(tinymce, uuid, shortcodeOnClick, false);
    } else if (templateToAdd === getMultiStepQuizWithLoaderTemplate()) {
      multiStepQuizConfig(tinymce, uuid, shortcodeOnClick, true);
    } else if (templateToAdd === getMultiStepQuizV2Template()) {
      multiStepQuizV2Config(tinymce, uuid, shortcodeOnClick, false);
    } else if (templateToAdd === getMultiStepQuizV2WithLoaderTemplate()) {
      multiStepQuizV2Config(tinymce, uuid, shortcodeOnClick, true);
    } else if (templateToAdd === getMultiStepQuizV3Template()) {
      multiStepQuizV3Config(tinymce, uuid, shortcodeOnClick);
    } else if (templateToAdd === getMultiStepQuizV4Template()) {
      multiStepQuizV4Config(tinymce, uuid, shortcodeOnClick);
    } else if (templateToAdd === getToastTemplate()) {
      toastConfig(tinymce, uuid, shortcodeOnClick, false);
    } else if (templateToAdd === getLiveChatTemplate()) {
      liveChatConfig(tinymce, uuid, shortcodeOnClick, false);
    } else if (templateToAdd === getLiveChatAutoTemplate()) {
      liveChatAutoConfig(tinymce, uuid, shortcodeOnClick, false);
    } else if (templateToAdd === getAudioFormTemplate()) {
      audioFormConfig(tinymce, uuid, shortcodeOnClick, false);
    } else if (templateToAdd === getBottomBarTemplate()) {
      bottomBarConfig(tinymce, uuid, shortcodeOnClick, false);
    } else if (templateToAdd === getContentSplitTemplate()) {
      contentSplitConfig(tinymce, uuid, shortcodeOnClick, false);
    } else if (templateToAdd === getCommentsTemplate()) {
      commentsWidgetConfig(tinymce, uuid, shortcodeOnClick);
    } else if (templateToAdd === getDripFormTemplate()) {
      dripFormConfig(tinymce, uuid, shortcodeOnClick);
    } else if (templateToAdd === getCtaButtonNumberTemplate()) {
      ctaButtonNumberConfig(tinymce, uuid, shortcodeOnClick);
    } else if (templateToAdd === getCTAPhoneTemplate()) {
      ctaPhoneConfig(tinymce, uuid, shortcodeOnClick);
    } else if (templateToAdd === getShortcodeHTMLTemplate()) {
      customHTMLAdditionConfig(tinymce, uuid, shortcodeOnClick);
    } else if (templateToAdd === getSelectAgeIconsTemplate()) {
      selectAgeIconsConfig(tinymce, uuid, shortcodeOnClick);
    } else if (templateToAdd === getMileageTemplate()) {
      selectMileageConfig(tinymce, uuid, shortcodeOnClick);
    } else if (templateToAdd === getMultiButtonCta()) {
      multiButtonCtaConfig(tinymce, uuid, shortcodeOnClick);
    } else if (templateToAdd === getWhiteMultiButtonCta()) {
      whiteMultiButtonCtaConfig(tinymce, uuid, shortcodeOnClick);
    } else if (templateToAdd === getDynamicColorMultiButtonCta()) {
      dynamicColorMultiCtaConfig(tinymce, uuid, shortcodeOnClick);
    } else if (templateToAdd === getMultiButtonCtaV3Template()) {
      multiButtonCtaV3Config(tinymce, uuid, shortcodeOnClick);
    } else if (templateToAdd === getMultiButtonCtaV4Template()) {
      multiButtonCtaV4Config(tinymce, uuid, shortcodeOnClick);
    } else if (templateToAdd === getButtonsWithTextBoxTemplate()) {
      buttonsWithTextBoxConfig(tinymce, uuid, shortcodeOnClick);
    } else if (api.getData().shortcodesAddition.includes('data-tiny-mce-component="contactform"')) {
      tinymce.activeEditor.windowManager.open({
        title: "Contact Form Options",
        body: emailFormAdditionItems,
        buttons: [
          {
            type: "cancel",
            name: "close",
            text: "Cancel",
          },
          {
            type: "submit",
            name: "submit",
            text: "Add",
            primary: true,
          },
        ],
        onSubmit: api => {
          const contactForm = parseToHtml(templateToAdd);

          if (api.getData().sendEmailsToGroove === true) {
            contactForm.getElementById("contact-form").setAttribute("send-email", true);
          }

          shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, contactForm.body.innerHTML);
          addShortcodeToEditor(shortcodeWrapper, uuid, parentElement, api);
          api.close();
        },
      });
    } else if (templateToAdd === getMultiButtonCtaWithImages()) {
      multiButtonWithImagesConfig(tinymce, uuid, shortcodeOnClick);
    } else if (templateToAdd === getTimerTemplate()) {
      timerConfig(tinymce, uuid, shortcodeOnClick);
    } else if (templateToAdd === getAnimatedButtonTemplate()) {
      animatedButtonConfig(tinymce, uuid, shortcodeOnClick);
    } else if (templateToAdd === getCounterTemplate()) {
      counterConfig(tinymce, uuid, shortcodeOnClick);
    } else if (templateToAdd === getCarrierNamesOtcTemplate()) {
      carrierNamesConfig(tinymce, uuid, shortcodeOnClick, api, "otc");
    } else if (templateToAdd === getCarrierNamesPartBTemplate()) {
      carrierNamesConfig(tinymce, uuid, shortcodeOnClick, api, "partb");
    } else if (templateToAdd === getZipCodeTemplate()) {
      shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd, "zip-code-shortcode");
      addShortcodeToEditor(shortcodeWrapper, uuid, parentElement, api, false, true);

      dynamicShortcodeAddition.body.items = templateItems;
    } else if (templateToAdd === getCountdownTemplate()) {
      countdownConfig(tinymce, uuid, shortcodeOnClick, false);
    } else {
      shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd);

      addShortcodeToEditor(shortcodeWrapper, uuid, parentElement, api);

      dynamicShortcodeAddition.body.items = templateItems;
    }

    api.close();
  },
};

const removeOnClickDivs = editor => {
  const parsedContent = parseToHtml(editor.getContent());
  parsedContent.querySelectorAll("[data-shortcode-remove-onclick]").forEach(e => e.parentNode.removeChild(e));
  editor.setContent(parsedContent.body.innerHTML);
};

const addOnClickDivs = editor => {
  const parsedContent = parseToHtml(editor.getContent());
  parsedContent.querySelectorAll("[data-shortcode-remove-onclick]").forEach(e => e.parentNode.removeChild(e));
  parsedContent.querySelectorAll(".shortcode").forEach(e => {
    const divToAdd = document.createElement("div");
    divToAdd.innerHTML = shortcodeOnClick;
    e.prepend(divToAdd.firstChild);
  });

  editor.setContent(parsedContent.body.innerHTML);

  editor.dom.select(".shortcode").forEach(e => {
    includeOnClickEventListener(e);
  });
};

const parseToHtml = content => {
  return new DOMParser().parseFromString(content, "text/html");
};

const includeOnClickEventListener = element => {
  element.firstChild.addEventListener("click", e => {
    e.target.parentNode.remove();
  });
};

/**
 * Trimming shortcode content prevents tinymce from inserting a newline right after the shortcode.
 */
const addShortcodeToEditor = (shortcodeWrapper, uuid, parentElement, api, insertWrapper = true, trim = false) => {
  const shortcodeContent = trim ? shortcodeWrapper.trim() : shortcodeWrapper;
  if (tinymce.activeEditor.selection.getNode().closest(".shortcode") === null) {
    if (tinymce.activeEditor.isDirty()) {
      tinymce.activeEditor.execCommand("mceInsertContent", false, shortcodeContent + "<p></p>");
    } else if (insertWrapper) {
      tinymce.activeEditor.execCommand("mceInsertContent", false, "<p>&emsp;</p>" + shortcodeContent + "<p>&emsp;</p>");
    } else {
      tinymce.activeEditor.execCommand("mceInsertContent", false, shortcodeContent);
    }
    includeOnClickEventListener(tinymce.activeEditor.dom.select("#" + uuid)[0]);

    dynamicShortcodeAddition.body.items = templateItems;
  } else {
    tinymce.activeEditor.notificationManager.open({
      text: "Can't add shortcode in this position!",
      type: "error",
    });
  }
};

/**
 * Wraps custom shortcode inside a wrapper
 *  - Wrapper contains dom element required to remove a shortcode
 *
 * Wrapper contains all the data required to visualize and serialize shortcode to vue component.
 * @param {*} uuid
 * @param {*} shortcodeOnClick
 * @param {*} templateToAdd
 * @param {*} domIdentifier identifier for the wrapper dom element.
 * @returns
 */
const getShortcodeWrapper = (uuid, shortcodeOnClick, templateToAdd, wrapperDomIdentifier = "") => {
  return `
  <div class="shortcode" id="${uuid}" data-wrapper-id="${wrapperDomIdentifier}">
    ${shortcodeOnClick}
    ${templateToAdd}
  </div>
  `;
};

const getSpanShortcodeWrapper = (
  uuid,
  shortcodeOnClick,
  templateToAdd,
  wrapperDomIdentifier = "",
  removeOnClick = true,
) => {
  return `
  <span class="${
    removeOnClick ? "shortcode" : "shortcode-no-onclick"
  }" id="${uuid}" data-wrapper-id="${wrapperDomIdentifier}">
  ${removeOnClick ? shortcodeOnClick : ""}
    ${templateToAdd}
  </span>
  `;
};

export {
  dynamicShortcodeAddition,
  templateItems,
  removeOnClickDivs,
  addOnClickDivs,
  getShortcodeWrapper,
  getSpanShortcodeWrapper,
  addShortcodeToEditor,
};
